import Decimal from "decimal.js"

const csvCell = (value: unknown) => {
	const text = value === null || value === undefined ? "" : String(value)
	return `"${text.replace(/"/g, '""')}"`
}

const TRANSACTION_CSV_COLUMNS: Array<{
	header: string
	value: (transaction: ICompanyTrxTransaction) => unknown
}> = [
	{ header: "ID", value: (transaction) => transaction.id },
	{ header: "Date", value: (transaction) => transaction.created_at },
	{ header: "Status", value: (transaction) => transaction.status },
	{ header: "Direction", value: (transaction) => transaction.direction },
	{ header: "Amount", value: (transaction) => new Decimal(transaction.amount).div(100).toFixed(2) },
	{ header: "Currency", value: (transaction) => transaction.currency },
	{ header: "Description", value: (transaction) => transaction.description },
	{ header: "Buyer", value: (transaction) => transaction.buyer_name },
	{ header: "Team", value: (transaction) => transaction.team_name },
	{ header: "Card", value: (transaction) => transaction.card_name },
	{ header: "Card mask", value: (transaction) => transaction.card_mask },
	{ header: "BIN", value: (transaction) => transaction.card_bin },
	{ header: "Operation ID", value: (transaction) => transaction.operation_id },
	{ header: "Parent trade number", value: (transaction) => transaction.parent_trade_no }
]

export const createTransactionsCsv = (transactions: ICompanyTrxTransaction[]) =>
	[
		TRANSACTION_CSV_COLUMNS.map((column) => csvCell(column.header)).join(","),
		...transactions.map((transaction) =>
			TRANSACTION_CSV_COLUMNS.map((column) => csvCell(column.value(transaction))).join(",")
		)
	].join("\r\n")
